module.exports = __webpack_public_path__ + "img/LoginAndRegisterBg.fec415e4.png";